import { Flex } from '@chakra-ui/react';
import { memo, useCallback } from 'react';
import { ContentImage } from '~/screens/SearchContent/components/ContentImage';
import { ISearchContentResult } from '~/searchApi';
import { convertPxToRems } from '~/utils-ts';

interface Props {
  content: ISearchContentResult;
  onClick?: (content: ISearchContentResult) => void;
  trackId?: string;
}

export const ContentCell: React.FC<Props> = memo(
  ({ onClick, content, trackId }) => {
    const { assets } = content;

    const handleContentClick = useCallback(() => {
      onClick?.(content);
    }, [content, onClick]);

    return (
      <Flex
        // Set `width` and `height` properties to prevent flickering
        // and scrolling issues
        width={32}
        height={28}
        margin={2}
        onClick={handleContentClick}
        cursor="pointer"
      >
        <ContentImage
          src={assets?.[0]?.previewUrl ?? assets?.[0]?.url}
          objectFit="cover"
          fallbackImageProps={{
            width: 28,
            height: 28,
          }}
          borderRadius={convertPxToRems(5)}
          trackId={trackId}
        />
      </Flex>
    );
  },
);
